<template>
  <div v-show="isShow.isPTShow" class="pageTwo">
    <div class="imgWrapper scaleToShow" id="imgWrapper" :style="{height: fnHeight * .42 + 'px'}">
      <img :src="showImgSrc" alt="">
      <p class="para shine">长按保存海报</p>
    </div>
    <canvas id="myCanvas"></canvas>
    <img :src="fnSrc" id="tempImg" alt="">
    <div class="btnGroup">
      <div class="btn btnLeft" @click="playAgain"></div>
      <div class="btn btnRight" @click="showMask"></div>
    </div>
    <div class="mask" v-show="isMaskShow" @click="hideMask">
      <div class="share"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PageOne',
  props: {
    isShow: {
      type: Object
    },
    fnSrc: {
      type: String
    },
    fnHeight: {
      type: Number
    }
  },
  data() {
    return {
      isMaskShow: false,
      showImgSrc: null
    }
  },
  methods: {
    showNext () {
      this.isShow.isKVShow = true
      this.isShow.isPTShow = false
    },
    showMask() {
      this.isMaskShow = true;
    },
    hideMask() {
      this.isMaskShow = false;
    },
    playAgain() {
      window.location.href = 'https://www.jiandoukeji.com/h5/2019/baojie/';
    },
    cropImage() {
      const myCanvas = document.getElementById('myCanvas');
      const ctx = myCanvas.getContext('2d');
      const img = document.getElementById('tempImg');

      myCanvas.width = 750;
      myCanvas.height = this.fnHeight;

      ctx.drawImage(img, 0, 0, 750, this.fnHeight, 0, 0, 750, this.fnHeight);
      this.showImgSrc = myCanvas.toDataURL('image/jpeg', 0.6);
    }
  },
  watch: {
    fnSrc() {
      setTimeout(() => {
        this.cropImage();
      }, 200);
    }
  }
}
</script>

<style lang="less" scoped>
.pageTwo {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  background-image: url('./fn-bg.jpg');
  background-size: cover;
  background-repeat: no-repeat;
  .imgWrapper {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 17.6875rem /* 283/16 */;
    // max-height: 31.75rem /* 508/16 */;
    margin-top: -5rem /* 80/16 */;
    background-color: #fff;
    box-shadow: 0 4px 5px 0 rgba(0,0,0,0.14), 0 1px 10px 0 rgba(0,0,0,0.12), 0 2px 4px -1px rgba(0,0,0,0.2);
    transition: all .6s ease-in;
    img {
      width: 96%;
      transition: all .4s ease-out;
    }
    .para {
      position: absolute;
      bottom: -1.25rem /* 20/16 */;
      font-size: .75rem /* 12/16 */;
      color: #333;
    }
  }
  #myCanvas {
    display: none;
  }
  #tempImg {
    display: none;
  }
  .btnGroup {
    position: absolute;
    box-sizing: border-box;
    bottom: 1.25rem /* 20/16 */;
    width: 100%;
    padding: 0 6%;
    display: flex;
    justify-content: space-between;
    .btn {
      width: 8.9375rem /* 143/16 */;
      height: 2.5rem /* 40/16 */;
      background-repeat: no-repeat;
      background-size: cover;
    }
    .btnLeft {
      background-image: url('./btn-again.png');
    }
    .btnRight {
      background-image: url('./btn-share.png');
    }
  }
  .mask {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, .6);
    z-index: 10;
    .share {
      position: absolute;
      right: 1.25rem /* 20/16 */;
      top: 1.25rem /* 20/16 */;
      width: 18.125rem /* 290/16 */;
      height: 17.625rem /* 282/16 */;
      background-size: cover;
      background-repeat: no-repeat;
      background-image: url('./mask-share.png');
    }
  }
}

@media (max-device-height:568px) and (-webkit-min-device-pixel-ratio:2){/* 兼容iphone5*/
  .imgWrapper {
    transform-origin: center;
    transform: scale(.9);
  }
}

@media only screen and (min-height: 550px) and (max-height: 600px)  { /*iphone6和iphone6 s 兼容底部白条*/
  .imgWrapper {
    transform-origin: center;
    transform: scale(.9);
  }
}

@media only screen and (min-height: 610px) and (max-height: 640px)  { /*iphone6 plus 兼容底部白条*/
  .imgWrapper {
    transform-origin: center;
    transform: scale(.9);
  }
}

.shine {
  animation: shine 1s ease-in infinite;
  animation-delay: 1s;
  animation-fill-mode: both;
}

@keyframes shine {
  0% {
    opacity: 0;
  }
  60%, 100% {
    opacity: 1;
  }
}

.scaleToShow {
  animation: scaleToShow 1s ease-in;
}

@keyframes scaleToShow {
  from {
    opacity: 0;
    transform-origin: center;
    transform: scale(.4);
  }
  to {
    opacity: 1;
    transform-origin: center;
    transform: scale(1);
  }
}
</style>
